module.exports = __webpack_public_path__ + "static/img/user1.0c6c36af.png";